module.exports = __webpack_public_path__ + "img/bilibili-home.6d723c30.png";